// SPDX-License-Identifier: AGPL-3.0-or-later

export function guardVoiceConnectionChoice(shouldProceed: () => boolean, onCancel: () => void): boolean {
	if (shouldProceed()) return true;
	onCancel();
	return false;
}
